import { fetcher } from '@commenda/utils';
import {
  TIndirectTaxCustomerBulkActionParams,
  TIndirectTaxCustomerBulkDeleteResult,
} from './types';

export async function bulkDeleteIndirectTaxCustomers(
  filters: TIndirectTaxCustomerBulkActionParams,
  token?: string
): Promise<TIndirectTaxCustomerBulkDeleteResult> {
  try {
    const response = await fetcher(
      'new-sales-tax/customers/bulk/delete',
      { method: 'POST', body: { filters } },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to bulk delete customers',
      };
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Customers deleted successfully',
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to bulk delete customers';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
